import { Navigate } from "react-router-dom";
import { useUserMe } from "@/lib/useUserMe";

interface Props {
  children: React.ReactNode;
}

/**
 * Client-side admin gate. Server still enforces via requireRole("admin"); this
 * is purely UX so non-admins don't see a 403 from the API.
 */
export function AdminGuard({ children }: Props) {
  const me = useUserMe();
  if (me.isLoading) {
    return (
      <div className="px-10 py-10">
        <span className="text-[10px] uppercase tracking-[0.18em] text-muted animate-pulse">
          Checking access…
        </span>
      </div>
    );
  }
  if (me.data?.user?.role !== "admin") {
    return <Navigate to="/app" replace />;
  }
  return <>{children}</>;
}
